import { render, staticRenderFns } from "./commonIll.vue?vue&type=template&id=01bfaf8c&scoped=true&"
import script from "./commonIll.vue?vue&type=script&lang=js&"
export * from "./commonIll.vue?vue&type=script&lang=js&"
import style0 from "./commonIll.vue?vue&type=style&index=0&id=01bfaf8c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01bfaf8c",
  null
  
)

export default component.exports